export type SwipeAxis = "pending" | "horizontal" | "vertical";
export const SWIPE_SLOP = 12;
export function swipeThreshold(width: number): number {
  return Math.max(72, Math.min(112, width * 0.28));
}
export function swipeAxis(previous: SwipeAxis, dx: number, dy: number): SwipeAxis {
  if (previous !== "pending" || Math.max(Math.abs(dx), Math.abs(dy)) < SWIPE_SLOP) return previous;
  if (Math.abs(dx) >= Math.abs(dy) * 1.25) return "horizontal";
  if (Math.abs(dy) >= Math.abs(dx) * 1.25) return "vertical";
  return "pending";
}
export function swipeDecision(axis: SwipeAxis, dx: number, dy: number, width: number): "like" | "pass" | null {
  if (axis !== "horizontal" || Math.abs(dx) < swipeThreshold(width) || Math.abs(dx) < Math.abs(dy) * 1.25) return null;
  return dx > 0 ? "like" : "pass";
}
